import { Action } from 'redux';

import { FavoriteItemType } from '../../../ts/ServerApi/types/IFavorite';
import { AddContentFavorite, ContentFavoriteAdded, ContentFavoriteRemoved, RemoveContentFavorite, RemoveFavoritedItemAction } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface AddContentFavoriteAction extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export function addContentFavorite(contentId: string, contentType: FavoriteItemType):
    AddContentFavoriteAction {
  return {
    type: AddContentFavorite,
    contentId,
    contentType
  };
}

export const isAddContentFavoriteAction = isActionFactory<AddContentFavoriteAction>(AddContentFavorite);

export interface ContentFavoriteAddedAction extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export function contentFavoriteAdded(contentId: string, contentType: FavoriteItemType) {
  return {
    type: ContentFavoriteAdded,
    contentId,
    contentType
  };
}

export const isContentFavoriteAddedAction = isActionFactory<ContentFavoriteAddedAction>(ContentFavoriteAdded);

export interface RemoveContentFavoriteAction extends Action {
  contentId: string;
  contentIdForFavoriting: string;
  contentName: string;
  contentType: FavoriteItemType;
}

export function removeContentFavorite(contentId: string, contentIdForFavoriting: string, contentType: FavoriteItemType, contentName: string):
    RemoveContentFavoriteAction {
  return {
    type: RemoveContentFavorite,
    contentId,
    contentIdForFavoriting,
    contentType,
    contentName
  };
}

export const isRemoveContentFavoriteAction = isActionFactory<RemoveContentFavoriteAction>(RemoveContentFavorite);

export interface ContentFavoriteRemovedAction extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export function contentFavoriteRemoved(contentId: string, contentType: FavoriteItemType): ContentFavoriteRemovedAction {
  return {
    type: ContentFavoriteRemoved,
    contentId,
    contentType
  };
}

export const isContentFavoriteRemovedAction = isActionFactory<ContentFavoriteRemovedAction>(ContentFavoriteRemoved);

export interface RemoveFavoritedItemAction extends Action {
  contentId: string;
  contentType: FavoriteItemType;
}

export function removeFavoritedItemAction(contentId: string, contentType: FavoriteItemType): RemoveFavoritedItemAction {
  return {
    type: RemoveFavoritedItemAction,
    contentId,
    contentType
  };
}

export const isRemoveFavoritedItemAction = isActionFactory<RemoveFavoritedItemAction>(RemoveFavoritedItemAction);
